/*
export function someGetter (state) {
}
*/

export function getCurrAssessment (state) {
    return state.currAssessmentState
}